import React, { act, useContext, useEffect, useMemo, useState } from "react";
import {
  LaunchableContext,
  formatDailyLaunchableMetrics,
} from "contexts/LaunchableContext";
import MultiSelectDropdown from "components/UI-lib/MultiSelectDropDown";
import { AreaChart } from "components/Graphs/AreaGraph";
import { OneClickDeployContext } from "contexts/OneClickDeployContext";
import { classNames } from "components/utils";
import { LaunchableAnalyticsTimeSeries } from "server";
import {
  transformLaunchableMetricsForChart,
  generateLaunchableDisplayKeys,
} from "../utils/chartUtils";
import { SelectionPopover } from "./SelectionPopover";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "components/Graphs/Select";

const placeholdeData = [
  {
    date: "May 1",
    "TensorRT Launchable (...123)": 2890,
    "Llama3 NeMo Launchable (...abc)": 2338,
  },
  {
    date: "May 2",
    "TensorRT Launchable (...123)": 2756,
    "Llama3 NeMo Launchable (...abc)": 2103,
  },
  {
    date: "May 3",
    "TensorRT Launchable (...123)": 3322,
    "Llama3 NeMo Launchable (...abc)": 2194,
  },
  {
    date: "May 4",
    "TensorRT Launchable (...123)": 3470,
    "Llama3 NeMo Launchable (...abc)": 2108,
  },
  {
    date: "May 5",
    "TensorRT Launchable (...123)": 3475,
    "Llama3 NeMo Launchable (...abc)": 1812,
  },
  {
    date: "May 6",
    "TensorRT Launchable (...123)": 3129,
    "Llama3 NeMo Launchable (...abc)": 1726,
  },
  {
    date: "May 7",
    "TensorRT Launchable (...123)": 3490,
    "Llama3 NeMo Launchable (...abc)": 1982,
  },
  {
    date: "May 8",
    "TensorRT Launchable (...123)": 2903,
    "Llama3 NeMo Launchable (...abc)": 2012,
  },
  {
    date: "May 9",
    "TensorRT Launchable (...123)": 2643,
    "Llama3 NeMo Launchable (...abc)": 2342,
  },
  {
    date: "May 10",
    "TensorRT Launchable (...123)": 2837,
    "Llama3 NeMo Launchable (...abc)": 2473,
  },
  {
    date: "May 11",
    "TensorRT Launchable (...123)": 2954,
    "Llama3 NeMo Launchable (...abc)": 3848,
  },
  {
    date: "May 12",
    "TensorRT Launchable (...123)": 3239,
    "Llama3 NeMo Launchable (...abc)": 3736,
  },
  {
    date: "May 13",
    "TensorRT Launchable (...123)": 2324,
    "Llama3 NeMo Launchable (...abc)": 1800,
  },
  {
    date: "May 14",
    "TensorRT Launchable (...123)": 4343,
    "Llama3 NeMo Launchable (...abc)": 1920,
  },
  {
    date: "May 15",
    "TensorRT Launchable (...123)": 3200,
    "Llama3 NeMo Launchable (...abc)": 1234,
  },
  {
    date: "May 16",
    "TensorRT Launchable (...123)": 2303,
    "Llama3 NeMo Launchable (...abc)": 2100,
  },
  {
    date: "May 17",
    "TensorRT Launchable (...123)": 3300,
    "Llama3 NeMo Launchable (...abc)": 2500,
  },
  {
    date: "May 18",
    "TensorRT Launchable (...123)": 3230,
    "Llama3 NeMo Launchable (...abc)": 1800,
  },
  {
    date: "May 19",
    "TensorRT Launchable (...123)": 3004,
    "Llama3 NeMo Launchable (...abc)": 1750,
  },
  {
    date: "May 20",
    "TensorRT Launchable (...123)": 3600,
    "Llama3 NeMo Launchable (...abc)": 2200,
  },
  {
    date: "May 21",
    "TensorRT Launchable (...123)": 2543,
    "Llama3 NeMo Launchable (...abc)": 2100,
  },
  {
    date: "May 22",
    "TensorRT Launchable (...123)": 3232,
    "Llama3 NeMo Launchable (...abc)": 2000,
  },
  {
    date: "May 23",
    "TensorRT Launchable (...123)": 2000,
    "Llama3 NeMo Launchable (...abc)": 1400,
  },
  {
    date: "May 24",
    "TensorRT Launchable (...123)": 3234,
    "Llama3 NeMo Launchable (...abc)": 1234,
  },
  {
    date: "May 25",
    "TensorRT Launchable (...123)": 2400,
    "Llama3 NeMo Launchable (...abc)": 1700,
  },
  {
    date: "May 26",
    "TensorRT Launchable (...123)": 2405,
    "Llama3 NeMo Launchable (...abc)": 1600,
  },
  {
    date: "May 27",
    "TensorRT Launchable (...123)": 4300,
    "Llama3 NeMo Launchable (...abc)": 1800,
  },
  {
    date: "May 28",
    "TensorRT Launchable (...123)": 4400,
    "Llama3 NeMo Launchable (...abc)": 1400,
  },
  {
    date: "May 29",
    "TensorRT Launchable (...123)": 2345,
    "Llama3 NeMo Launchable (...abc)": 1324,
  },
  {
    date: "May 30",
    "TensorRT Launchable (...123)": 3245,
    "Llama3 NeMo Launchable (...abc)": 1200,
  },
];

interface LaunchableGraphProps {
  dailyMetrics: {
    [launchableId: string]: LaunchableAnalyticsTimeSeries[];
  };
  loadingDailyMetrics: boolean;
}

const LaunchableGraph: React.FC<LaunchableGraphProps> = ({
  dailyMetrics,
  loadingDailyMetrics,
}) => {
  const launchableContext = useContext(LaunchableContext);

  const [selectedValues, setSelectedValues] = useState<string[]>(["None"]);

  const metricOptions = ["Views", "Deploys"];
  const [selectedMetric, setSelectedMetric] = useState<string>("Views");

  const [displayLaunchableKeys, setDisplayLaunchableKeys] = useState<string[]>(
    []
  );

  // Transform displayLaunchableKeys into format for SelectionPopover
  const launchableItems = useMemo(() => {
    return displayLaunchableKeys.map((launchable) => ({
      id: launchable,
      label: launchable,
    }));
  }, [displayLaunchableKeys]);

  useEffect(() => {
    if (launchableContext.activelaunchables.length === 0) {
      return;
    }

    const launchableKeys = generateLaunchableDisplayKeys(
      launchableContext.activelaunchables
    );

    const defaultKeys = launchableKeys.slice(0, 3);
    setSelectedValues(defaultKeys);
    const restOfLaunchables = launchableContext.activelaunchables.filter(
      (launchable) => {
        return !launchableKeys.includes(
          `${launchable.name} (...${launchable.id.slice(-5)})`
        );
      }
    );
    setDisplayLaunchableKeys([
      ...launchableKeys,
      ...restOfLaunchables.map(
        (launchable) => `${launchable.name} (...${launchable.id.slice(-5)})`
      ),
    ]);
  }, [launchableContext.activelaunchables]);

  // Transform dailyMetrics into the format expected by AreaChart
  const displayLaunchableGraphMapping = useMemo(() => {
    return transformLaunchableMetricsForChart(
      dailyMetrics,
      selectedValues,
      selectedMetric,
      launchableContext.activelaunchables
    );
  }, [
    dailyMetrics,
    selectedValues,
    selectedMetric,
    launchableContext.activelaunchables,
  ]);

  return (
    <div className="flex flex-col">
      <div className="flex flex-row justify-between">
        <div className="flex flex-col justify-start mb-3">
          <h1 className="text-xl font-medium dark:text-white">
            Launchable Insights
          </h1>
          <p className="text-sm text-gray-700 dark:text-secondary">
            Last 30 days
          </p>
        </div>
        <div className="flex flex-row dark:text-secondary justify-end">
          <div className="flex flex-row justify-end">
            <div className="w-full mr-3 min-w-[350px] max-w-[350px]">
              <span className="text-sm text-secondary">
                Specify Launchables
              </span>
              <SelectionPopover
                items={launchableItems}
                selectedValues={selectedValues}
                onSelectionChange={setSelectedValues}
                placeholder="Select Launchables..."
                className="w-full"
              />
            </div>
            <div className="w-full min-w-[150px]">
              <span className="text-sm text-secondary">Select Metric</span>
              <Select
                value={selectedMetric}
                onValueChange={(value) => setSelectedMetric(value)}
              >
                <SelectTrigger className="h-10">
                  <SelectValue placeholder="Select Metric" />
                </SelectTrigger>
                <SelectContent>
                  {metricOptions.map((metric) => (
                    <SelectItem key={metric} value={metric}>
                      {metric}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          </div>
        </div>
      </div>
      <div className="flex mt-3">
        {loadingDailyMetrics || Object.keys(dailyMetrics).length === 0 ? (
          <div className="flex relative w-full">
            <div
              className={classNames(
                "absolute top-[20%] z-50",
                loadingDailyMetrics ? "left-[48%]" : "left-[45%]"
              )}
            >
              <span className="text-white font-bold">
                {loadingDailyMetrics ? "Loading..." : "No Data Available"}
              </span>
            </div>
            <AreaChart
              className="opacity-15 h-80"
              data={placeholdeData}
              showTooltip={false}
              showLegend={false}
              disableHoverDots={true}
              index="date"
              categories={[
                "TensorRT Launchable (...123)",
                "Llama3 NeMo Launchable (...abc)",
              ]}
              intervalType="preserveStartEnd"
            />
          </div>
        ) : (
          <>
            <AreaChart
              className="h-80"
              data={displayLaunchableGraphMapping}
              index="date"
              showLegend={
                selectedValues.length > 0 && selectedValues[0] !== "None"
              }
              minValue={
                selectedValues.length > 0 && selectedValues[0] !== "None"
                  ? undefined
                  : 0
              }
              maxValue={
                selectedValues.length > 0 && selectedValues[0] !== "None"
                  ? undefined
                  : 200
              }
              categories={selectedValues}
              onValueChange={(v) => console.log(v)}
              intervalType="preserveStartEnd"
            />
          </>
        )}
      </div>
    </div>
  );
};

export default LaunchableGraph;
